import { render, staticRenderFns } from "./bookingNotifyFormatAddress.vue?vue&type=template&id=098b42d4&scoped=true&"
import script from "./bookingNotifyFormatAddress.vue?vue&type=script&lang=js&"
export * from "./bookingNotifyFormatAddress.vue?vue&type=script&lang=js&"
import style0 from "./bookingNotifyFormatAddress.vue?vue&type=style&index=0&id=098b42d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "098b42d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('098b42d4')) {
      api.createRecord('098b42d4', component.options)
    } else {
      api.reload('098b42d4', component.options)
    }
    module.hot.accept("./bookingNotifyFormatAddress.vue?vue&type=template&id=098b42d4&scoped=true&", function () {
      api.rerender('098b42d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaExport/components/booking/bookingNotifyFormatAddress.vue"
export default component.exports